import {
  getExpCode,
  getMetaCvExpType,
  getMetaCvReagentApplication,
  getMetaCvExpSeparationMethod,
  getMetaCvExpDigestEnzyme,
  getMetaCvExpDigestProtocol,
  getProjectCv,
  getMetaCvOmicsType,
  getUserListCvByProjectId,
  getExpIdbyCodes,
  getExpCodeByIds,
  getCvProteomicsSubcellularOrganelle,
  getCvProteomicsProtocol,
  /*instrument*/
  getMetaCvExpInstrumentManufacturer,
  getMetaCvExpInstrument,
  getMetaCvExpInstrumentAnalyzer,
  getMetaCvExpInstrumentAnalyzerTolerance,
  saveExpInstrumentation,
  getExpInstrumentation,
  modifyExpInstrumentation,
  /*add del modify paste*/
  saveExpInfo,
  getExpView,
  getExpInfo,
  modifyExpInfo,
  deleteExp,
  getExperimentTemplate,
  /*table*/
  getExpListCount,
  getExpListData,
  /*drafts*/
  getExpDraftList,
  getExpDraftInfo,
  deleteExpDraftInfo,
  saveExpDraftInfo,
  getProjectExpDraftList,
  /*db search*/
  getCvSearchParamName,
  saveExpSearchParameters,
  getCvSearchParamValue,
  getMetaCvModifications,
  getExpSearchParameters,
  modifyExpSearchParameters,
  getCvDatabase
} from 'api/experiments'
const experiments = {
  state: {
    experimentActiveIndex: 1,
    samNextDisabled: true,
    samDraftsDisabled: true,
    subList: {},
    createSubList: {},
    modifySubList: {},
    expType: [],
    projectName: [],
    omicsType: [],
    prepApplication: [],
    sepMethod: [],
    digEnzyme: [],
    digProtocol: [],
    insManufacture: [],
    instrumentList: [],
    instAnalyzer: [],
    insTolerance: [],
    subcellularOrganelleList: [],
    proteomicsProtocolList: [],
    /*
    drafts exp state
    */
    generalList: {
      projectName: '',
      projectId: '',
      expName: '',
      expCode: '',
      expType: '',
      expTypeId: '',
      omicsType: '',
      omicsTypeId: '',
      rmk: '',
      registrantName: '',
      registrantId: 1,
      registrationDate: ''
    },
    sampleList: [],
    prepFormList: [
      {
        reagentId: '',
        reagentName: '',
        reagentCode: '',
        washBuffers: '',
        application: '',
        applicationId: '',
        amount: '',
        amountUnit: '',
        amountUnitId: '',
        amountType: '',
        amountTypeId: '',
        rmk: '',
        operatedDate: '',
        operatorName: 'wangjingjing',
        operatorId: 1
      }
    ],
    sepFormList: [
      {
        buffer: '',
        separationMethod: '',
        source: '',
        size: '',
        phOthers: '',
        operatedDate: '',
        operatorName: 'wangjingjing',
        operatorId: 1
      }
    ],
    digFormList: {
      protocol: '',
      protocolId: '',
      enzyme: '',
      enzymeId: '',
      operatedDate: '',
      operatorName: 'wangjingjing',
      operatorId: 1
    },
    insFormList: [
      {
        manufacturerId: '',
        manufacturerName: '',
        instrumentId: '',
        instrumentName: '',
        analyzerId: '',
        analyzerName: '',
        tolerance: '',
        toleranceUnit: '',
        msN: 1,
        operatedDate: '',
        operatorName: 'wangjingjing',
        operatorId: 1,
        rmk: ''
      }
    ],
    msList: [{
      order: 1,
      fractionNumber: 1,
      mode: 'ftp',
      rmk: ''
    }],
    comments: '',
    draftGeneralCode: '',
    /*
    modify exp state
    */
    modifyGeneralList: {
      id: null,
      projectName: '',
      projectId: '',
      expName: '',
      expCode: '',
      omicsType: '',
      omicsTypeId: '',
      expType: '',
      expTypeId: '',
      rmk: '',
      registrantName: 'wangjingjing',
      registrantId: 1,
      registrationDate: ''
    },
    modifySampleList: [],
    modifyPrepFormList: [
      {
        expId: null,
        id: null,
        reagentId: '',
        reagentName: '',
        reagentCode: '',
        washBuffers: '',
        application: '',
        applicationId: '',
        amount: '',
        amountUnit: '',
        amountUnitId: '',
        amountType: '',
        amountTypeId: '',
        rmk: '',
        operatedDate: '',
        operatorName: 'wangjingjing',
        operatorId: 1
      }
    ],
    modifySepFormList: [
      {
        expId: null,
        id: null,
        buffer: '',
        separationMethod: '',
        source: '',
        size: '',
        phOthers: '',
        operatedDate: '',
        operatorName: 'wangjingjing',
        operatorId: 1
      }
    ],
    modifyDigFormList: {
      expId: null,
      id: null,
      protocol: '',
      protocolId: '',
      enzyme: '',
      enzymeId: '',
      operatedDate: '',
      operatorName: 'wangjingjing',
      operatorId: 1
    },
    modifyInsFormList: [
      {
        expId: null,
        id: null,
        manufacturerId: '',
        manufacturerName: '',
        instrumentId: '',
        instrumentName: '',
        analyzerId: '',
        analyzerName: '',
        tolerance: '',
        toleranceUnit: '',
        msN: 1,
        operatedDate: '',
        operatorName: 'wangjingjing',
        operatorId: 1,
        rmk: ''
      }
    ],
    modifyMsList: [{
      expId: null,
      id: null,
      order: 1,
      fractionNumber: 1,
      mode: 'ftp',
      rmk: ''
    }],
    modifyComments: '',
    // dbsearch
    dbSearchList: {},
    databaseNameList: [],
    dynamicCvList: []
  },
  mutations: {
    SET_DBSEARCHLIST: (state, list) => {
      state.dbSearchList = list
    },
    SET_EMPTYEXPIDLIST: (state, list) => {
      state.expIdList = list
    },
    SET_EXPERACTIVEINDEX (state, res) {
      state.experimentActiveIndex = res
    },
    SET_SAMNEXTDISABLED: (state, boolean) => {
      state.samNextDisabled = boolean
    },
    SET_SAMDRAFTSDISABLED: (state, boolean) => {
      state.samDraftsDisabled = boolean
    },
    SET_DRAFTGENERALCODE: (state, expCode) => {
      state.draftGeneralCode = expCode
    },
    SET_EXPPROJECTNAME: (state, list) => {
      state.projectName = list
    },
    SET_OMICSTYPE: (state, list) => {
      state.omicsType = list.map((item) => {
        return {label: item.label, value: item.id}
      })
      // console.log(state.omicsType)
    },
    SET_SUBCEllORGAN: (state, list) => {
      state.subcellularOrganelleList = list.map((item) => {
        return {label: item.label, value: item.id}
      })
    },
    SET_PROTEOMICSPROTOCOL: (state, list) => {
      state.proteomicsProtocolList = list.map((item) => {
        return {label: item.label, value: item.id}
      })
    },
    /*drafts exp mutations*/
    SET_GENERALLIST: (state, list) => {
      state.generalList = list
    },
    SET_SAMLIST: (state, list) => {
      state.sampleList = list
    },
    SET_PREPFORMLIST: (state, list) => {
      state.prepFormList = list
    },
    SET_SEPFORMLIST: (state, list) => {
      state.sepFormList = list
    },
    SET_DIGFORMLIST: (state, list) => {
      state.digFormList = list
    },
    SET_INSFORMLIST: (state, list) => {
      state.insFormList = list
    },
    SET_COMFORMLIST: (state, list) => {
      state.comments = list
    },
    SET_SUBLIST: (state, list) => {
      state.subList[list.key] = list.formValue
    },
    SET_EMPTYSUBLIST: (state, list) => {
      state.subList = list
    },
    SET_CREATESUBLIST: (state, list) => {
      state.createSubList[list.key] = list.formValue
    },
    SET_EMPTYLIST: (state, list) => {
      state.createSubList = list
    },
    SET_EXPTYPE: (state, list) => {
      state.expType = list
    },
    /*modify exp mutations*/
    SET_MODIFYGENERALLIST: (state, list) => {
      state.modifyGeneralList = list
    },
    SET_MODIFYSAMPLELIST: (state, list) => {
      state.modifySampleList = list
    },
    SET_MODIFYPREPLIST: (state, list) => {
      state.modifyPrepFormList = list
    },
    SET_MODIFYSEPLIST: (state, list) => {
      state.modifySepFormList = list
    },
    SET_MODIFYDIGLIST: (state, list) => {
      state.modifyDigFormList = list
    },
    SET_MODIFYINSLIST: (state, list) => {
      state.modifyInsFormList = list
    },
    SET_MODIFYMSLIST: (state, list) => {
      state.modifyMsList = list
    },
    SET_MODIFYCOMMENTSLIST: (state, list) => {
      state.modifyComments = list
    },
    SET_MODIFYSUBLIST: (state, list) => {
      state.modifySubList[list.key] = list.formValue
    },
    SET_EMPTYMODIFYSUBLIST: (state, list) => {
      state.modifySubList = list
    },
    /*cv mutations*/
    // prepration
    SET_METAPREPAPPLICATION: (state, list) => {
      state.prepApplication = list
    },
    // sepration
    SET_METASEPMETHOD: (state, list) => {
      state.sepMethod = list
    },
    SET_METADIGENZYME: (state, list) => {
      state.digEnzyme = list
    },
    SET_METADIGPROTOCOL: (state, list) => {
      state.digProtocol = list
    },
    // instrument
    SET_METAINSMANUFACTURE: (state, list) => {
      state.insManufacture = list
    },
    SET_METAINSTRUMENTLIST: (state, list) => {
      state.instrumentList = list
    },
    SET_METAINSANALYZER: (state, list) => {
      state.instAnalyzer = list
    },
    SET_METAINSTOLERANCE: (state, list) => {
      state.insTolerance = list
    },
    // ms
    SET_METAEXPMSLIST: (state, list) => {
      state.msList = list
    },
    // dbsearch
    SET_DATABASENAME: (state, list) => {
      state.databaseNameList = list.map((item) => {
        return {
          label: item.alise_name,
          value: item.id
        }
      })
      console.log(state.databaseNameList)
    },
    SET_DYNAMICCVLIST: (state, list) => {
      state.dynamicCvList = list.map((item) => {
        return {
          label: item.label,
          value: item.id
        }
      })
    },
    SET_EMPTYDYNAMICCVLIST: (state, list) => {
      state.dynamicCvList = list
    }
  },
  actions: {
    getCvProteomicsSubcellularOrganelle ({commit}) {
      return new Promise((resolve, reject) => {
        getCvProteomicsSubcellularOrganelle().then((res) => {
          commit('SET_SUBCEllORGAN', res.result.data)
          resolve(res.result.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getCvProteomicsProtocol ({commit}) {
      return new Promise((resolve, reject) => {
        getCvProteomicsProtocol().then((res) => {
          commit('SET_PROTEOMICSPROTOCOL', res.result.data)
          resolve(res.result.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getExpIdbyCodes ({commit}, data) {
      return new Promise((resolve, reject) => {
        getExpIdbyCodes(data).then((res) => {
          resolve(res.result.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getExpCodeByIds ({commit}, data) {
      return new Promise((resolve, reject) => {
        getExpCodeByIds(data).then((res) => {
          resolve(res.result.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getOperatorCVList ({commit}, data) {
      return new Promise((resolve, reject) => {
        getUserListCvByProjectId(data).then((res) => {
          resolve(res.result)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getDBSearchList ({commit}, list) {
      commit('SET_DBSEARCHLIST', list)
    },
    getExperimentActiveIndex ({commit}, index) {
      commit('SET_EXPERACTIVEINDEX', index)
    },
    getSamNextDisabled ({commit, state}, boolean) {
      commit('SET_SAMNEXTDISABLED', boolean)
    },
    getSamDraftsDisabled ({commit, state}, boolean) {
      commit('SET_SAMDRAFTSDISABLED', boolean)
    },
    getGeneralExpCode ({commit, state}) {
      return new Promise((resolve, reject) => {
        getExpCode().then((res) => {
          // console.log(res.result.expCode)
          commit('SET_DRAFTGENERALCODE', res.result.expCode)
          resolve(res.result.expCode)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getProjectName ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        getProjectCv(data).then((res) => {
          commit('SET_EXPPROJECTNAME', res.result)
          resolve(res.result)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getOmicsType ({commit, state}) {
      return new Promise((resolve, reject) => {
        getMetaCvOmicsType().then((res) => {
          commit('SET_OMICSTYPE', res.result.data)
          resolve(res.result.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /*drafts exp actions*/
    getExpGeneralFormList ({commit, state}, list) {
      commit('SET_GENERALLIST', list)
    },
    getExpSamFormList ({commit, state}, list) {
      commit('SET_SAMLIST', list)
    },
    getExpPrepFormList ({commit, state}, list) {
      commit('SET_PREPFORMLIST', list)
    },
    getExpSepFormList ({commit, state}, list) {
      commit('SET_SEPFORMLIST', list)
    },
    getExpDigFormList ({commit, state}, list) {
      commit('SET_DIGFORMLIST', list)
    },
    getExpInsFormList ({commit, state}, list) {
      commit('SET_INSFORMLIST', list)
    },
    getExpComFormList ({commit, state}, list) {
      commit('SET_COMFORMLIST', list)
    },
    getExpSubList ({commit}, list) {
      commit('SET_SUBLIST', list)
    },
    getEmptySubList ({commit}, list) {
      commit('SET_EMPTYSUBLIST', list)
    },
    getCreateExpSublist ({commit}, list) {
      commit('SET_CREATESUBLIST', list)
    },
    getEmptyCreateSubList ({commit}, list) {
      commit('SET_EMPTYLIST', list)
    },
    /*modify exp actions*/
    getModifyExpGeneralList ({commit, state}, list) {
      commit('SET_MODIFYGENERALLIST', list)
    },
    getModifyExpSamplesList ({commit, state}, list) {
      commit('SET_MODIFYSAMPLELIST', list)
    },
    getModifyExpPrepList ({commit, state}, list) {
      commit('SET_MODIFYPREPLIST', list)
    },
    getModifyExpSepList ({commit, state}, list) {
      commit('SET_MODIFYSEPLIST', list)
    },
    getModifyDigList ({commit, state}, list) {
      commit('SET_MODIFYDIGLIST', list)
    },
    getModifyInsList ({commit, state}, list) {
      commit('SET_MODIFYINSLIST', list)
    },
    getModifyMsList ({commit, state}, list) {
      commit('SET_MODIFYMSLIST', list)
    },
    getModifyCommentsList ({commit, state}, list) {
      commit('SET_MODIFYCOMMENTSLIST', list)
    },
    getModifyExpSubList ({commit}, list) {
      commit('SET_MODIFYSUBLIST', list)
    },
    getEmptyModifyExpSubList ({commit, state}, list) {
      commit('SET_EMPTYMODIFYSUBLIST', list)
    },
    /*cCV acctions*/
    getMetaExpType ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        getMetaCvExpType(data).then((res) => {
          commit('SET_EXPTYPE', res.result.data)
          resolve(res.result.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // prepration
    getMetaExpApplication ({commit, state}) {
      return new Promise((resolve, reject) => {
        getMetaCvReagentApplication().then((res) => {
          commit('SET_METAPREPAPPLICATION', res.result.data)
          resolve(res.result.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // sepration
    getMetaSepMethod ({commit, state}) {
      return new Promise((resolve, reject) => {
        getMetaCvExpSeparationMethod().then((res) => {
          commit('SET_METASEPMETHOD', res.result.data)
          resolve(res.result.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getMetaDigEnzyme ({commit, state}) {
      return new Promise((resolve, reject) => {
        getMetaCvExpDigestEnzyme().then((res) => {
          commit('SET_METADIGENZYME', res.result.data)
          resolve(res.result.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getMetaDigProtocol ({commit, state}) {
      return new Promise((resolve, reject) => {
        getMetaCvExpDigestProtocol().then((res) => {
          commit('SET_METADIGPROTOCOL', res.result.data)
          resolve(res.result.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // instrument
    getCreateInsSublist ({commit}, list) {
      commit('SET_CREATESUBLIST', list)
    },
    modifyExpInstrumentationList ({commit}, list) {
      return new Promise((resolve, reject) => {
        modifyExpInstrumentation(list).then((res) => {
          resolve(res)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    setEmptyIdLsit ({commit}, list) {
      commit('SET_EMPTYEXPIDLIST', list)
    },
    getMetaManufacture ({commit, state}) {
      return new Promise((resolve, reject) => {
        getMetaCvExpInstrumentManufacturer().then((res) => {
          commit('SET_METAINSMANUFACTURE', res.result.data)
          resolve(res.result.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getMetaInstrumentList ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        getMetaCvExpInstrument(data).then((res) => {
          commit('SET_METAINSTRUMENTLIST', res.result.data)
          resolve(res.result.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getMetaInsAnaylzer ({commit, state}) {
      return new Promise((resolve, reject) => {
        getMetaCvExpInstrumentAnalyzer().then((res) => {
          commit('SET_METAINSANALYZER', res.result.data)
          resolve(res.result.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getMetaInsTolerance ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        getMetaCvExpInstrumentAnalyzerTolerance(data).then((res) => {
          commit('SET_METAINSTOLERANCE', res.result.data)
          resolve(res.result.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getCreateInsList ({commit}, list) {
      return new Promise((resolve, reject) => {
        saveExpInstrumentation(list).then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getExpInstrumentationList ({commit}, list) {
      return new Promise((resolve, reject) => {
        getExpInstrumentation(list).then((res) => {
          resolve(res.result.metaExperimentInstrumentations)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // ms
    getMetaMSList ({commit}, list) {
      commit('SET_METAEXPMSLIST', list)
    },
    /*add del modify*/
    getCreateExpList ({commit}, data) {
      return new Promise((resolve, reject) => {
        saveExpInfo(data).then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getExpCheckViewList ({commit}, data) {
      return new Promise((resolve, reject) => {
        getExpView(data).then((res) => {
          resolve(res.result)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getExpInfoList ({commit}, data) {
      return new Promise((resolve, reject) => {
        getExpInfo(data).then((res) => {
          resolve(res.result)
        }).catch(error => {
          reject(error)
        })
      })
    },
    delMetaExp ({commit}, data) {
      return new Promise((resolve, reject) => {
        deleteExp(data).then((res) => {
          resolve(res)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getModifyExpList ({commit}, data) {
      return new Promise((resolve, reject) => {
        modifyExpInfo(data).then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /*multi*/
    getExperimentTemplateInfo ({commit}, data) {
      return new Promise((resolve, reject) => {
        getExperimentTemplate(data).then((res) => {
          resolve(res.result)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /*table*/
    getExpTableList ({commit}, data) {
      return new Promise((resolve, reject) => {
        getExpListData(data).then((res) => {
          resolve(res.result)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getExpTableCount ({commit}, data) {
      return new Promise((resolve, reject) => {
        getExpListCount(data).then((res) => {
          resolve(res.result)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /*draft*/
    // {commit}必须写
    getExpDraftList ({commit}, data) {
      return new Promise((resolve, reject) => {
        saveExpDraftInfo(data).then((res) => {
          // console.log(res)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getProjectDraftList ({commit}, data) {
      return new Promise((resolve, reject) => {
        getProjectExpDraftList(data).then((res) => {
          // console.log(res)
          resolve(res.result.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getExpDraftTableList ({commit}, data) {
      return new Promise((resolve, reject) => {
        getExpDraftList(data).then((res) => {
          resolve(res.result.list)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getExpDraftInfoList ({commit}, data) {
      return new Promise((resolve, reject) => {
        getExpDraftInfo(data).then((res) => {
          resolve(res.result)
        }).catch(error => {
          reject(error)
        })
      })
    },
    delMetaDraftExp ({commit}, data) {
      return new Promise((resolve, reject) => {
        deleteExpDraftInfo(data).then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getExpDraftCode ({commit}, expCode) {
      commit('SET_DRAFTGENERALCODE', expCode)
    },
    // db search
    getDatabaseNameList ({commit}) {
      return new Promise((resolve, reject) => {
        getCvDatabase().then((res) => {
          console.log(res)
          commit('SET_DATABASENAME', res.result.data)
          resolve(res.result.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getCvSearchParamName ({commit}, data) {
      return new Promise((resolve, reject) => {
        getCvSearchParamName(data).then((res) => {
          // console.log(res.result.data)
          resolve(res.result.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    saveCreateSearchList ({commit}, list) {
      return new Promise((resolve, reject) => {
        saveExpSearchParameters(list).then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    modifyExpSearchParametersList ({commit}, list) {
      return new Promise((resolve, reject) => {
        modifyExpSearchParameters(list).then((res) => {
          resolve(res)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getExpSearchParamsList ({commit}, list) {
      return new Promise((resolve, reject) => {
        getExpSearchParameters(list).then((res) => {
          resolve(res.result.metaProtoSearch)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getCvSearchParamValue ({commit}, data) {
      return new Promise((resolve, reject) => {
        getCvSearchParamValue(data).then((res) => {
          commit('SET_DYNAMICCVLIST', res.result.data)
          resolve(res.result.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getEmptyDynamicCvList ({commit}, empty) {
      commit('SET_EMPTYDYNAMICCVLIST', empty)
    },
    getMetaCvModifications ({commit}) {
      return new Promise((resolve, reject) => {
        getMetaCvModifications().then((res) => {
          resolve(res.result.data)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  }
}

export default experiments



// WEBPACK FOOTER //
// ./src/store/modules/experiments.js